import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import JasonFile from "./formLangfields.json";
import { Buffer } from 'buffer';
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import useRecorder from "../utils/useRecorder.js";
import { SignOut, SpeakerHigh, CaretLeft } from 'phosphor-react';
import mlj from "../helper/images/mlj.png";
import moe_logo from "../helper/images/moe_logo.png";
import anu_logo from "../helper/images/anuvadini_logo.png"

function RequestListPage() {
    const navigate = useNavigate();
    const [isLogin, setIsLogin] = useState(false);
    const [selectLang, setLang] = useState();
    const [audioURL] = useRecorder();
    const [data, setData] = useState([]);
    const [IsLogin, setlegalIsLogin] = useState(false);
    const [audioSrc, setAudioSrc] = useState();
    const [buf, setBuf] = useState();
    const [play, SetPlay] = useState(false);
    const [prevAudio, setPrevAudio] = useState(null);
    const [role, SetRole] = useState();

    const [inputList, setinputList] = useState([{
        ["_id"]: "",
        Act: [],
        keyword: "",
        Assamese_Value: "",
        Assamese_Value_verified: false,
        Assamese_Value_verified_at: "",
        Assamese_Value_verified_by: "",
        Bengali_Value: "",
        Bengali_Value_verified: false,
        Bengali_Value_verified_at: "",
        Bengali_Value_verified_by: "",
        Gujarati_Value: "",
        Gujarati_Value_verified: false,
        Gujarati_Value_verified_at: "",
        Gujarati_Value_verified_by: "",
        Hindi_Value: "",
        Hindi_Value_verified: false,
        Hindi_Value_verified_at: "",
        Hindi_Value_verified_by: "",
        Kannada_Value: "",
        Kannada_Value_verified: false,
        Kannada_Value_verified_at: "",
        Kannada_Value_verified_by: "",
        Malayalam_Value: "",
        Malayalam_Value_verified: false,
        Malayalam_Value_verified_at: "",
        Malayalam_Value_verified_by: "",
        Marathi_Value: "",
        Marathi_Value_verified: false,
        Marathi_Value_verified_at: "",
        Marathi_Value_verified_by: "",
        Oriya_Value: "",
        Oriya_Value_verified: false,
        Oriya_Value_verified_at: "",
        Oriya_Value_verified_by: "",
        Punjabi_Value: "",
        Punjabi_Value_verified: false,
        Punjabi_Value_verified_at: "",
        Punjabi_Value_verified_by: "",
        Tamil_Value: "",
        Tamil_Value_verified: false,
        Tamil_Value_verified_at: "",
        Tamil_Value_verified_by: "",
        Telugu_Value: "",
        Telugu_Value_verified: false,
        Telugu_Value_verified_at: "",
        Telugu_Value_verified_by: "",
        Urdu_Value: "",
        Urdu_Value_verified: false,
        Urdu_Value_verified_at: "",
        Urdu_Value_verified_by: "",
        Word: "",
        category: "",
        isverify: false,
        original_language: ""
    }]);

    const handleLogout = () => {
        localStorage.setItem("legalIsLogin", false);
        localStorage.removeItem("legaltoken");
        navigate("/lawdictionary");
    };
    const handleLogin = () => {
        navigate("/lawdictionary/login");
    };

    useEffect(() => {
        const lang = localStorage.getItem("legalLanguage");
        const legalIsLogin = localStorage.getItem("legalIsLogin");
        let isLogin = localStorage.getItem("legalIsLogin");
        setIsLogin(isLogin);
        setlegalIsLogin(legalIsLogin);
        setLang(lang);

        const token = localStorage.getItem("legaltoken");
        if (token) {
            const usrRole = jwt_decode(token).role
            SetRole(usrRole);
        }
        GetRequestList(token);
    }, []);

    const HandleAddButton = () => {
        navigate("/lawdictionary/add-new");
    }

    const getBuf = data => {
        return Buffer.from(data, "binary");
    }

    const handlePlay = (query, lang) => {
        let voice = JasonFile[3][lang];
        let Body = query;
        const post = { Body: Body, language: lang, voice: voice };
        axios.post('https://voiceapi.aicte-india.org/text-to-voice', post)
            .then(res => {
                const audioFile = getBuf(res.data.data.audio.data)
                let blob = new Blob([audioFile], { type: 'audio/wav' });
                setBuf(blob);
                let url = URL.createObjectURL(blob);
                setAudioSrc(url);
            });
    }

    useEffect(() => {
        if (prevAudio) {
            prevAudio.pause();
            prevAudio.currentTime = 0;
        }
        const aud = new Audio(audioSrc);
        aud.play();
        setPrevAudio(aud);
    }, [audioSrc])

    const actView = (data, key, audioLang) => {
        return data.map(item => {
            return (
                <>
                    {item.Act_id ? <><strong>Act: </strong><p>{item.Act_id}</p></> : <></>}
                    {item[key] ? <>
                        <strong>Meaning: </strong>
                        <p className="paraText">
                            <p>{item[key]}</p>
                            <SpeakerHigh size={20} onClick={(e) => { handlePlay(item[key], audioLang) }} className="w-auto mr-3" /></p>
                    </> : <></>}
                </>
            )
        })
    };

    const GetRequestList = (data) => {
        let post = { user_id: data };
        axios.post(process.env.REACT_APP_BASE_URL + "verify/getRequestListUser", post, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem('legaltoken')}`
            },
        })
            .then(function (response) {
                if (response.data.status == "success") {
                    let data = response.data.response;
                    let completedata = [];
                    {
                        data.map(res => {
                            var newData = res.law_data;
                            newData['status'] = res.status;
                            newData['is_deleted'] = res.is_deleted;
                            completedata.push(newData);
                            setData(completedata);
                            setinputList(completedata);
                        })
                    };
                } else {
                    setData([]);
                    setinputList({});
                }
            });

    };

    return (
        <>
            <div className="topDiv searchList">
                <header className="headerLst">
                    <div className="container mainSrchDiv">
                        <div className="mainSrchDivIn">
                            <div className="row align-items-center">
                                <div className="logoarea col-12 col-sm-12 col-md-9 col-lg-9">
                                    <div className="d-flex justify-content-start flex-wrap align-items-center">
                                        <div className="listLogo">
                                            <a href="https://anuvadini.aicte-india.org/">
                                                <img src={anu_logo} width="210px" />
                                            </a>
                                            <a>
                                                <img src={mlj} alt="" width="200px" style={{ marginLeft: 10 }} />
                                            </a>
                                            <a href="">
                                                <img src={moe_logo} alt="" style={{ marginLeft: 10, }} width="120px" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                                    <div className="d-flex justify-content-end align-items-center phonecenter">
                                        <div className="d-flex justify-content-end flex-wrap buttonmargin">
                                            <button className="feedbackSpn h-auto w-auto mr-3" style={{ height: 36, }} onClick={() => { navigate('/lawdictionary') }}>
                                                Home
                                            </button>
                                            <button className="feedbackSpn h-auto w-auto" style={{ height: 36, marginBottom: 5 }} onClick={() => HandleAddButton()}>
                                                Add New Record
                                            </button>
                                            {role == 'admin' ? <button className="feedbackSpn h-auto w-auto" style={{ marginLeft: '10px' }} onClick={() => { navigate('/lawdictionary/register-validator') }}>Create Validator Account</button> : <></>}

                                        </div>
                                        <button className="feedbackSpn h-auto w-auto" style={{ marginLeft: '10px' }} onClick={() => { navigate('/lawdictionary/home') }}>A to Z Words</button>
                                        {isLogin == "true" ? (
                                            <>
                                                <div className="d-flex justify-content-end buttonmargin">
                                                    <div className="wrapper signout">
                                                        <button className="button w-auto" onClick={() => handleLogout()}><b><SignOut size={32} /></b>
                                                        </button>
                                                    </div>
                                                </div>
                                            </>) : (<>
                                                <div className="wrapper">
                                                    <button className="button w-auto" onClick={() => handleLogin()} > <b>Login</b></button>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                <p style={{ color: 'blue', textDecoration: "underline", }} onClick={() => { navigate('/lawdictionary') }}><CaretLeft size={20} /> Back</p>
                <section className="searchListSec">
                    <div className="container-fluid">
                        {
                            data.length > 0 ?
                                data.map(item => {
                                    return (
                                        <>
                                            <div className="srchListOne _l3">
                                                <div className="srchOntBtm">
                                                    <div className="srchOneTp">
                                                        {item.status === false && item.is_deleted === false ? <><button className="feedbackSpn h-auto w-auto btn-warning" style={{ height: 38 }}>  Pending</button></> : ""}
                                                        {item.status === false && item.is_deleted === true ? <><button className="feedbackSpn h-auto w-auto btn-danger" style={{ height: 38 }}> Rejected</button></> : ""}
                                                        {item.status === true && item.is_deleted === false ? <><button className="feedbackSpn h-auto w-auto btn-success" style={{ height: 38 }}>Accepted</button></> : ""}

                                                        <div className="ml-4">
                                                            <div className="srchOneRgt">
                                                                <h4 className="srchFrHdng">
                                                                    <strong>{item[JasonFile[1][selectLang]]}</strong>

                                                                    <div className='speekers'>
                                                                        {item[JasonFile[1][selectLang]] ? <>
                                                                            <SpeakerHigh size={20} onClick={(e) => { handlePlay(item[JasonFile[1][selectLang]], 'hi-IN') }} className="w-auto mr-3" />
                                                                        </> : <></>}

                                                                    </div>
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="newtext">
                                                        <h3>
                                                            {actView(item.Act, JasonFile[1][selectLang], selectLang)}
                                                        </h3>
                                                        <h5>Category : {item.category}</h5>
                                                        <h5>Keywords : {item[JasonFile[6][selectLang]].join(', ')}</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                }
                                ) :
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    No Requests
                                </div>
                        }
                    </div>
                </section>
            </div>
        </>
    );
}


export default RequestListPage;
